__turbopack_context__.v({
  "imgWrapper": "Card-module-scss-module__UTMWXW__imgWrapper",
});
